import { default as aboutZI5NQg6EZVMeta } from "/Users/pavel/Work/xsquare-2024/pages/about.vue?macro=true";
import { default as buyMsDDHBOCw4Meta } from "/Users/pavel/Work/xsquare-2024/pages/buy.vue?macro=true";
import { default as demoyH2yiaw9ssMeta } from "/Users/pavel/Work/xsquare-2024/pages/demo.vue?macro=true";
import { default as docs8p8FUBag2WMeta } from "/Users/pavel/Work/xsquare-2024/pages/docs.vue?macro=true";
import { default as downloadcXmt1BmDSkMeta } from "/Users/pavel/Work/xsquare-2024/pages/download.vue?macro=true";
import { default as index5KcQd5f9fVMeta } from "/Users/pavel/Work/xsquare-2024/pages/index.vue?macro=true";
import { default as aliancedTfe63oahxMeta } from "/Users/pavel/Work/xsquare-2024/pages/letters/aliance.vue?macro=true";
import { default as arpplVVMQayXvfMeta } from "/Users/pavel/Work/xsquare-2024/pages/letters/arpp.vue?macro=true";
import { default as arz_45vodokanal1F14W27XpdMeta } from "/Users/pavel/Work/xsquare-2024/pages/letters/arz-vodokanal.vue?macro=true";
import { default as blagojhddeNyT7vMeta } from "/Users/pavel/Work/xsquare-2024/pages/letters/blago.vue?macro=true";
import { default as gazfonddGo8AWRjcGMeta } from "/Users/pavel/Work/xsquare-2024/pages/letters/gazfond.vue?macro=true";
import { default as ktvrZoDyvbYSqMeta } from "/Users/pavel/Work/xsquare-2024/pages/letters/ktv.vue?macro=true";
import { default as kvgRsf8rhvCxIMeta } from "/Users/pavel/Work/xsquare-2024/pages/letters/kvg.vue?macro=true";
import { default as national_45npfjal3da3GZsMeta } from "/Users/pavel/Work/xsquare-2024/pages/letters/national-npf.vue?macro=true";
import { default as nationala0XPNGiawmMeta } from "/Users/pavel/Work/xsquare-2024/pages/letters/national.vue?macro=true";
import { default as nz_45vodokanalbZkn30LTIzMeta } from "/Users/pavel/Work/xsquare-2024/pages/letters/nz-vodokanal.vue?macro=true";
import { default as vtbiCPxrsDKWXMeta } from "/Users/pavel/Work/xsquare-2024/pages/letters/vtb.vue?macro=true";
import { default as lettersSaf6611ICQMeta } from "/Users/pavel/Work/xsquare-2024/pages/letters.vue?macro=true";
import { default as esiaYyO9moCHdIMeta } from "/Users/pavel/Work/xsquare-2024/pages/solutions/esia.vue?macro=true";
import { default as indextXCNZTaWABMeta } from "/Users/pavel/Work/xsquare-2024/pages/solutions/index.vue?macro=true";
import { default as insuransepAbSuXc3YrMeta } from "/Users/pavel/Work/xsquare-2024/pages/solutions/insuranse.vue?macro=true";
import { default as jelektronnye_zakaznye_pismaBzQIOPzEqKMeta } from "/Users/pavel/Work/xsquare-2024/pages/solutions/jelektronnye_zakaznye_pisma.vue?macro=true";
import { default as jelektronnyj_45arhivsg4GtNDHKuMeta } from "/Users/pavel/Work/xsquare-2024/pages/solutions/jelektronnyj-arhiv.vue?macro=true";
import { default as jelektronnyj_45dokumentooborotPly8W0XlXFMeta } from "/Users/pavel/Work/xsquare-2024/pages/solutions/jelektronnyj-dokumentooborot.vue?macro=true";
import { default as lichnyj_45kabinetV4F0DqzzbSMeta } from "/Users/pavel/Work/xsquare-2024/pages/solutions/lichnyj-kabinet.vue?macro=true";
import { default as mobilnaja_45razrabotkaqTF7jJsW39Meta } from "/Users/pavel/Work/xsquare-2024/pages/solutions/mobilnaja-razrabotka.vue?macro=true";
import { default as mobilnyj_45kontrolerFfKCrg6M66Meta } from "/Users/pavel/Work/xsquare-2024/pages/solutions/mobilnyj-kontroler.vue?macro=true";
import { default as pirUVCY2DWksVMeta } from "/Users/pavel/Work/xsquare-2024/pages/solutions/pir.vue?macro=true";
import { default as smjev8vLhd1DsmRMeta } from "/Users/pavel/Work/xsquare-2024/pages/solutions/smjev.vue?macro=true";
import { default as web_45phoneNDghFFRyqWMeta } from "/Users/pavel/Work/xsquare-2024/pages/solutions/web-phone.vue?macro=true";
import { default as xsquare_45crmgFsH6A5ZhLMeta } from "/Users/pavel/Work/xsquare-2024/pages/solutions/xsquare-crm.vue?macro=true";
import { default as xsquare_45help_45deskpGInOi5RQyMeta } from "/Users/pavel/Work/xsquare-2024/pages/solutions/xsquare-help-desk.vue?macro=true";
import { default as solutionsms9tbvu5UEMeta } from "/Users/pavel/Work/xsquare-2024/pages/solutions.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    meta: aboutZI5NQg6EZVMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/about.vue").then(m => m.default || m)
  },
  {
    name: "buy",
    path: "/buy",
    meta: buyMsDDHBOCw4Meta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/buy.vue").then(m => m.default || m)
  },
  {
    name: "demo",
    path: "/demo",
    meta: demoyH2yiaw9ssMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/demo.vue").then(m => m.default || m)
  },
  {
    name: "docs",
    path: "/docs",
    meta: docs8p8FUBag2WMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/docs.vue").then(m => m.default || m)
  },
  {
    name: "download",
    path: "/download",
    meta: downloadcXmt1BmDSkMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/download.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: index5KcQd5f9fVMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "letters",
    path: "/letters",
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/letters.vue").then(m => m.default || m),
    children: [
  {
    name: "letter-aliance",
    path: "aliance",
    meta: aliancedTfe63oahxMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/letters/aliance.vue").then(m => m.default || m)
  },
  {
    name: "letter-arpp",
    path: "arpp",
    meta: arpplVVMQayXvfMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/letters/arpp.vue").then(m => m.default || m)
  },
  {
    name: "letter-arz-vodokanal",
    path: "arz-vodokanal",
    meta: arz_45vodokanal1F14W27XpdMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/letters/arz-vodokanal.vue").then(m => m.default || m)
  },
  {
    name: "letter-blago",
    path: "blago",
    meta: blagojhddeNyT7vMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/letters/blago.vue").then(m => m.default || m)
  },
  {
    name: "letter-gazfond",
    path: "gazfond",
    meta: gazfonddGo8AWRjcGMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/letters/gazfond.vue").then(m => m.default || m)
  },
  {
    name: "letter-ktv",
    path: "ktv",
    meta: ktvrZoDyvbYSqMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/letters/ktv.vue").then(m => m.default || m)
  },
  {
    name: "letter-ktg",
    path: "kvg",
    meta: kvgRsf8rhvCxIMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/letters/kvg.vue").then(m => m.default || m)
  },
  {
    name: "letter-national-npf",
    path: "national-npf",
    meta: national_45npfjal3da3GZsMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/letters/national-npf.vue").then(m => m.default || m)
  },
  {
    name: "letter-national",
    path: "national",
    meta: nationala0XPNGiawmMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/letters/national.vue").then(m => m.default || m)
  },
  {
    name: "letter-nz-vodokanal",
    path: "nz-vodokanal",
    meta: nz_45vodokanalbZkn30LTIzMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/letters/nz-vodokanal.vue").then(m => m.default || m)
  },
  {
    name: "letter-vtb",
    path: "vtb",
    meta: vtbiCPxrsDKWXMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/letters/vtb.vue").then(m => m.default || m)
  }
]
  },
  {
    name: solutionsms9tbvu5UEMeta?.name,
    path: "/solutions",
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/solutions.vue").then(m => m.default || m),
    children: [
  {
    name: "solutions-esia",
    path: "esia",
    meta: esiaYyO9moCHdIMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/solutions/esia.vue").then(m => m.default || m)
  },
  {
    name: "solutions",
    path: "",
    meta: indextXCNZTaWABMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/solutions/index.vue").then(m => m.default || m)
  },
  {
    name: "solutions-insuranse",
    path: "insuranse",
    meta: insuransepAbSuXc3YrMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/solutions/insuranse.vue").then(m => m.default || m)
  },
  {
    name: "solutions-jelektronnye_zakaznye_pisma",
    path: "jelektronnye_zakaznye_pisma",
    meta: jelektronnye_zakaznye_pismaBzQIOPzEqKMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/solutions/jelektronnye_zakaznye_pisma.vue").then(m => m.default || m)
  },
  {
    name: "solutions-jelektronnyj-arhiv",
    path: "jelektronnyj-arhiv",
    meta: jelektronnyj_45arhivsg4GtNDHKuMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/solutions/jelektronnyj-arhiv.vue").then(m => m.default || m)
  },
  {
    name: "solutions-jelektronnyj-dokumentooborot",
    path: "jelektronnyj-dokumentooborot",
    meta: jelektronnyj_45dokumentooborotPly8W0XlXFMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/solutions/jelektronnyj-dokumentooborot.vue").then(m => m.default || m)
  },
  {
    name: "solutions-lk",
    path: "lichnyj-kabinet",
    meta: lichnyj_45kabinetV4F0DqzzbSMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/solutions/lichnyj-kabinet.vue").then(m => m.default || m)
  },
  {
    name: "solutions-xsquare-mobile-dev",
    path: "mobilnaja-razrabotka",
    meta: mobilnaja_45razrabotkaqTF7jJsW39Meta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/solutions/mobilnaja-razrabotka.vue").then(m => m.default || m)
  },
  {
    name: "mobilnyj-kontroler",
    path: "mobilnyj-kontroler",
    meta: mobilnyj_45kontrolerFfKCrg6M66Meta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/solutions/mobilnyj-kontroler.vue").then(m => m.default || m)
  },
  {
    name: "solutions-pir",
    path: "pir",
    meta: pirUVCY2DWksVMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/solutions/pir.vue").then(m => m.default || m)
  },
  {
    name: "solutions-smjev",
    path: "smjev",
    meta: smjev8vLhd1DsmRMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/solutions/smjev.vue").then(m => m.default || m)
  },
  {
    name: "solutions-web-phone",
    path: "web-phone",
    meta: web_45phoneNDghFFRyqWMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/solutions/web-phone.vue").then(m => m.default || m)
  },
  {
    name: "solutions-xsquare-crm",
    path: "xsquare-crm",
    meta: xsquare_45crmgFsH6A5ZhLMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/solutions/xsquare-crm.vue").then(m => m.default || m)
  },
  {
    name: "solutions-xsquare-help-desk",
    path: "xsquare-help-desk",
    meta: xsquare_45help_45deskpGInOi5RQyMeta || {},
    component: () => import("/Users/pavel/Work/xsquare-2024/pages/solutions/xsquare-help-desk.vue").then(m => m.default || m)
  }
]
  }
]